import { fromJS } from 'immutable';

import { createAsyncAction } from '../utils';
const emptyEditable = fromJS({
    main: {
        total: null,
        successful: null,
        failed: null,
        deploymentDuration: null,
        meanTime: null,
        failedRatio: null
    },
    changeVolume: null,
    deploymentFrequency: null,
    leadTime: null,
    activities: null
});

const initialState = fromJS({
    loading: false,
    error: null,
    editMode: false,
    actual: {
        main: {
            total: null,
            successful: null,
            failed: null,
            deploymentDuration: null,
            meanTime: null,
            failedRatio: null
        },
        changeVolume: null,
        deploymentFrequency: null,
        leadTime: null,
        activities: null
    },
    editable: emptyEditable
});

export const getSettings = createAsyncAction('GET_SETTINGS');
export const setSettings = createAsyncAction('UPDATE_SETTINGS');

export const EDIT_MODE_ENABLE = 'EDIT_MODE_ENABLE';
export const EDIT_MODE_DISABLE = 'EDIT_MODE_DISABLE';
export const EDIT_MODE_UPDATE_SETTINGS = 'EDIT_MODE_UPDATE_SETTINGS';

export default function settingsReducer(state = initialState, action) {
    switch (action.type) {
        case getSettings.REQUEST:
        case setSettings.REQUEST:
            return state
                .update('loading', () => true)
                .update('error', () => null);
        case getSettings.SUCCESS:
        case setSettings.SUCCESS:
            const { main, deploymentFrequency, leadTime, changeVolume, activities } = action.payload;
            return state
                .update('loading', () => false)
                .update('editMode', () => false)
                .update('editable', () => emptyEditable)
                .setIn(['actual', 'main'], fromJS(main))
                .setIn(['actual', 'deploymentFrequency'], fromJS(deploymentFrequency))
                .setIn(['actual', 'changeVolume'], fromJS(changeVolume))
                .setIn(['actual', 'leadTime'], fromJS(leadTime))
                .setIn(['actual', 'activities'], fromJS(activities));
        case getSettings.FAIL:
        case setSettings.FAIL:
            return state
                .update('loading', () => false)
                .update('error', () => action.payload);
        case EDIT_MODE_ENABLE:
            return state
                .update('editMode', () => true)
                .update('editable', () => fromJS(state.get('actual').toJS()));
        case EDIT_MODE_DISABLE:
            return state
                .update('editMode', () => false)
                .update('editable', () => fromJS(emptyEditable.toJS()));
        case EDIT_MODE_UPDATE_SETTINGS:
            return state
                .setIn(['editable', 'loading'], false)
                .setIn(['editable', 'editMode'], false)
                .setIn(['editable', 'main'], fromJS(action.payload.main))
                .setIn(['editable', 'deploymentFrequency'], fromJS(action.payload.deploymentFrequency))
                .setIn(['editable', 'changeVolume'], fromJS(action.payload.changeVolume))
                .setIn(['editable', 'leadTime'], fromJS(action.payload.leadTime))
                .setIn(['editable', 'activities'], fromJS(action.payload.activities));
        default:
            return state;
    }
};

export function settingsActions($http, api,$q) {
    'ngInject'

    function loadSettings() {
        return dispatch => {
            dispatch({ type: getSettings.REQUEST });
            return $http.get(`${api.restServiceUrlDB}settings`)
                .then(response => {
                    dispatch({ type: getSettings.SUCCESS, payload: response.data });
                }, error => {
                    dispatch({ type: getSettings.FAIL, error: true, payload: error.data });
                });
        };
    }

    function saveChanges(settings, editMode = false) {
        if (editMode) {
            return dispatch => {
                dispatch({ type: EDIT_MODE_UPDATE_SETTINGS, payload: settings });
                return $q.resolve();
            }
        };

        return dispatch => {
            dispatch({ type: setSettings.REQUEST });
            return $http.put(`${api.restServiceUrl}settings`, settings).then(() => {
                dispatch({ type: setSettings.SUCCESS, payload: settings });
            }, error => {
                dispatch({ type: setSettings.FAIL, error: true, payload: error.data });
            });
        };
    }

    function enableEditMode() {
        return { type: EDIT_MODE_ENABLE };
    }

    function disableEditMode() {
        return { type: EDIT_MODE_DISABLE };
    }

    return { loadSettings, saveChanges, enableEditMode, disableEditMode };
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/redux/settings.reducer.js